/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Max_Duration_SecondsInputs */



/**
* | output |
* | --- |
* | "Max Duration (seconds)" |
*
* @param {Max_Duration_SecondsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const max_duration_seconds = /** @type {((inputs?: Max_Duration_SecondsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Max_Duration_SecondsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Durée max (secondes)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Maximale Dauer (Sekunden)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Durata massima (secondi)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Максимальная продолжительность (в секундах)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Duración máxima (segundos)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("最大持续时间（秒）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最大継続時間（秒）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अधिकतम अवधि (सेकंड में)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Duração máxima (segundos)")
	return /** @type {LocalizedString} */ ("Max Duration (seconds)")
});